import styled from 'styled-components/native';

import OrderTitleDescription from 'components/OrderTitleDescription';

export default styled(OrderTitleDescription)<{ noMargin?: boolean }>`
  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '25')}px;
`;
